<template>
    <div class="app-wrapper" >
        <navigation-bar></navigation-bar>
        <div id="today-app" >
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import NavigationPerimeter from '../configs/Perimeters/navigation';
    import NavigationBar from './Header/navigation-bar';
    import { mapGetters } from 'vuex';


    export default {
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                user: 'getUser'
            }),
        },
        components: {
            NavigationBar,
            NavigationPerimeter
        },
        mounted() {
            let user = this.$store.getters.getUser;
            if (this.$route.path === '/' || this.$route.path === '') {
                if (user.role === 'ROLE_SUPER_ADMIN' ||
                    user.role === 'ROLE_ADMIN' ||
                    user.role === 'ROLE_CLIENT_ADMIN' ||
                    user.role === 'ROLE_AGENT_ADMIN'
                ) {
                    this.$router.push('/offices');
                } else if (user.permissions.canViewPastOrders) {
                    this.$router.push('/office/' + user.agency + '/campaigns');
                } else if (user.permissions.canViewMediaOrders) {
                    this.$router.push('/office/' + user.agency + '/property-campaigns/order');
                }
            }
        }
    }
</script>